import { Box } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import TextContent from './TextContent';
import ResponsiveSplitSection from '../common/ResponsiveSplitSection';
import { AboutSustainabilitySupplyChainContent } from '../../graphql/pimcore/modules/siteContent/types/AboutSustainabilityContent';
import SustainabilityContainer from './SustainabilityContainer';
import SupplyChainTab from './SupplyChainTab';

interface SupplyChainPageProps {
    cmsContent: AboutSustainabilitySupplyChainContent;
}

const SupplyChainPage: FunctionComponent<SupplyChainPageProps> = ({ cmsContent }) => {
    const textContent = (
        <Box sx={{ marginTop: '1rem' }}>
            <TextContent
                name={'supply-chain'}
                content1={<div dangerouslySetInnerHTML={{ __html: cmsContent.mainText.content }} />}
            />
        </Box>
    );
    return (
        <>
            <ResponsiveSplitSection
                textContent={textContent}
                backgroundColor={'white'}
                smallScreenTextFirst={false}
                imageSrc={cmsContent.mainImage.imageUrl}
                bigScreenAlignItem="flex-start"
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F8F8F8',
                }}
            >
                <SustainabilityContainer backgroundColor={'#F8F8F8'}>
                    <SupplyChainTab cmsContent={cmsContent} />
                </SustainabilityContainer>
            </Box>
        </>
    );
};

export default SupplyChainPage;
